module.exports = __webpack_public_path__ + "static/media/Autonomiq-Forgot-BG.167fe793.svg";